module.exports = __webpack_public_path__ + "img/desktop-2.20989638.jpg";